import slugify from "@sindresorhus/slugify";
import { graphql } from "gatsby";
import React, { Fragment, useCallback, useState } from "react";

const FaqQuestion = ({ item, isFirst }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = useCallback(() => setExpanded((value) => !value), []);
  return (
    <div className={`manuali__box-manuale manuali__box-manuale--faq ${expanded ? " open" : ""}`}>
      {isFirst ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,  jsx-a11y/no-noninteractive-element-to-interactive-role
        <h2 role="button" onClick={toggleExpanded} className="manuali__box-manuale-title">
          {item.question}
        </h2>
      ) : (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,  jsx-a11y/no-noninteractive-element-to-interactive-role
        <h3 role="button" onClick={toggleExpanded} className="manuali__box-manuale-title">
          {item.question}
        </h3>
      )}
      <div
        className="manuali__box-manuale-content"
        dangerouslySetInnerHTML={{ __html: item.answer }}
      ></div>
    </div>
  );
};
const FaqWashPass = ({ data, isFirst }) => {
  return (
    <>
      {data.anchorDesktop && (
        <span id={slugify(data.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <section className="section mb-4">
        <div className="container">
          <div className="row text-center">
            <div className="col-12 text-center">
              {isFirst ? (
                <h1 className="section__title mb-4">{data.titleFaq}</h1>
              ) : (
                <h2 className="section__title mb-4">{data.titleFaq}</h2>
              )}
              <>
                <div className="manuali__box-risultati">
                  {data.faq.map((item) => (
                    <Fragment key={item.question}>
                      {item?.question && item?.answer && (
                        <FaqQuestion item={item} isFirst={isFirst} />
                      )}
                    </Fragment>
                  ))}
                </div>
              </>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqWashPass;
export const fragment = graphql`
  fragment FaqWashPassFragment on LiferayFaq {
    anchorDesktop
    anchorMobile
    titleFaq
    faq {
      question
      answer
    }
  }
`;
